import React from "react";
import { useWatchState } from "@/store";
import { Modal, Button, Form, Input } from "antd";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};

const App = Form.create({ name: 'register' })((props) => {
    const { getFieldDecorator } = props.form;

    const [[{ title, show, hide, width = 800, vo = {} }]] = useWatchState(["modal.project"])

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    };

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={handleSubmit}>
                <Form.Item label="工程编号">
                    {getFieldDecorator('code', {
                        initialValue: vo.code,
                        rules: [
                            {
                                required: true,
                                message: '请输入工程编号！',
                            },
                        ],
                    })(<Input placeholder="请输入工程编号" />)}
                </Form.Item>
                <Form.Item label="工程名称">
                    {getFieldDecorator('name', {
                        initialValue: vo.name,
                        rules: [
                            {
                                required: true,
                                message: '请输入工程名称！',
                            },
                        ],
                    })(<Input />)}
                </Form.Item>
                <Form.Item label="工程注释">
                    {getFieldDecorator('comment', {
                        initialValue: vo.comment
                    })(<Input />)}
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
})

export default App;